import Api from '@/services/api';
//import qs from 'querystring';

export default {
  
  get(id) {
    return Api().get('/courrier/' + id);
  },
  getPreviewHTML(typeID, courrier) {
    return Api().post('/courrier/type/' + typeID +'/preview-html', 'courrier=' + encodeURIComponent(JSON.stringify(courrier)));
  },
  getPreviewPDF(typeID, courrier) {
    return Api().post('/courrier/type/' + typeID +'/preview-pdf', 'courrier=' + encodeURIComponent(JSON.stringify(courrier)));
  },
  getPreviewRCPDF(courrier) {
    return Api().post('/courrier/rc/preview-pdf', 'courrier=' + encodeURIComponent(JSON.stringify(courrier)));
  },
  create(courrier) {
    courrier.creancierID.options = null;
    return Api().post('/courrier', 'courrier=' + encodeURIComponent(JSON.stringify(courrier)));
  }
  
  
}